import { useState } from "react";

// ─── Queue Badge with inline edit ─────────────────────────────────────────────
const QueueBadge = ({ value, onUpdate, mode }) => {
  const [editing, setEditing] = useState(false);
  const [inputVal, setInputVal] = useState(value);

  const commit = () => {
    const n = parseInt(inputVal, 10);
    if (!isNaN(n) && n > 0) onUpdate(n);
    else setInputVal(value);
    setEditing(false);
  };

  if (editing) {
    return (
      <input
        autoFocus
        type="number"
        min={1}
        value={inputVal}
        onChange={(e) => setInputVal(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === "Enter") commit();
          if (e.key === "Escape") {
            setInputVal(value);
            setEditing(false);
          }
        }}
        style={{
          width: 36,
          border: "1.5px solid #4164E3",
          borderRadius: 4,
          padding: "1px 3px",
          fontSize: 11,
          fontWeight: 700,
          textAlign: "center",
          outline: "none",
          backgroundColor: mode ? "#2C2E33" : "#fff",
          color: mode ? "#fff" : "#000",
        }}
      />
    );
  }

  return (
    <div
      title="Click to set queue position"
      onClick={() => {
        setInputVal(value);
        setEditing(true);
      }}
      style={{
        width: 26,
        height: 26,
        borderRadius: "50%",
        backgroundColor: "#4164E3",
        color: "#fff",
        fontSize: 11,
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        userSelect: "none",
        flexShrink: 0,
      }}
    >
      {value}
    </div>
  );
};


export default QueueBadge;